import { useAuth0 } from '@auth0/auth0-react';
import welcomeImage from 'Assets/images/desktop-welcome.svg';
import bhiveLogo from 'Assets/images/logo.svg';
import {
  AUTH0_MANAGEMENT_API_SCOPE,
  AUTH0_SUCCESS_REDIRECT_URI,
} from 'Constants/env';
import React, { useCallback } from 'react';
import { pushToGTMDataLayer } from 'Utils/analytics';
import { sendIpcAuth0LoginUrl } from 'Utils/ipcRendererEvents';
import { Button } from '~/lib/ui/button';
import { AuthenticationLayout } from '../AuthenticationLayout';

export const DesktopWelcome = () => {
  const auth0 = useAuth0();

  const openAuth0LoginWindow = useCallback(async () => {
    pushToGTMDataLayer('desktop_login', {
      action: 'click',
      label: 'sign_in_button',
    });

    const auth0LoginUrl = await auth0.buildAuthorizeUrl({
      max_age: 0,
      redirectUri: AUTH0_SUCCESS_REDIRECT_URI,
      scope: AUTH0_MANAGEMENT_API_SCOPE,
    });

    sendIpcAuth0LoginUrl(auth0LoginUrl);
  }, [auth0]);

  return (
    <AuthenticationLayout rightImage={welcomeImage}>
      <img src={bhiveLogo} alt="BHive Logo" className="w-[250px] mb-11" />
      <h1 className="text-[30px] leading-[41px] mb-4 login-container">Welcome to Broadvoice.</h1>
      <p className="text-[18px] leading-[25px] mb-4">
        To access the Communicator app, please sign in to continue.
      </p>
      <Button onClick={() => void openAuth0LoginWindow()} size="lg">
        Sign in
      </Button>
    </AuthenticationLayout>
  );
};
